<template>
  <div class="container-fluid">
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6">
            <h3 class="mb-0">{{ $t("SYNC_LOGS.SYNC_LOGS_LIST") }}</h3>
          </div>
          <div class="col-6 text-right">
            <notification-subscription
              v-if="$currentUserCan($permissions.PERM_VIEW_SYNC_LOGS)"
              :objectType="'sync-logs'"
              :events="{
                CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
              }"
            />
          </div>
        </div>
      </div>

      <sync-log-list-table
        @onViewSyncLog="openSyncLogViewModal"
        @onEditSyncLog="openSyncLogEditModal"
        @onDeleteSyncLog="deleteSyncLog"
        :key="renderKey * 100"
      />

      <div
        v-if="isViewSyncLogModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isViewSyncLogModalOpened ? 'show' : 'hide']"
        :key="renderKey * 200"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'SYNC_LOG_VIEW'"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("SYNC_LOGS.VIEW_SYNC_LOG") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <notification-subscription
                v-if="openSyncLog"
                :objectType="'sync-logs'"
                :objectId="openSyncLog.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <!-- <button class="edit" @click="openSyncLogEditModal(openSyncLog)">
                  <i class="fal fa-edit"></i>
                  <span>{{ $t("COMMON.EDIT") }}</span>
                </button> -->
                <button class="delete" @click="deleteSyncLog(openSyncLog)">
                  <i class="fal fa-trash-alt"></i>
                  <span>{{ $t("COMMON.DELETE") }}</span>
                </button>
              </base-dropdown>
              <button class="close" @click="closeSyncLogModal">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <view-sync-log-component
              v-if="openSyncLog"
              :syncLogId="openSyncLog.id"
              @relunchSync="relunchSync"
              @toggleAttempts="toggleAttempts"
              @deleteSyncLog="deleteSyncLog"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isEditSyncLogModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isEditSyncLogModalOpened ? 'show' : 'hide']"
        :key="renderKey * 300"
      >
        <div class="resizable-wrapper-content" v-resizable-modal="'SYNC_LOG'">
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("SYNC_LOGS.EDIT_SYNC_LOG") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button class="view" @click="openSyncLogViewModal(openSyncLog)">
                  <i class="fal fa-expand-alt"></i>
                  <span>{{ $t("COMMON.VIEW") }}</span>
                </button>
              </base-dropdown>
              <button class="close" @click="closeSyncLogModal">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <edit-sync-log-component
              v-if="openSyncLog"
              :syncLogId="openSyncLog.id"
              @onViewSyncLog="openSyncLogViewModal"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isAddSyncLogModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isAddSyncLogModalOpened ? 'show' : 'hide']"
        :key="renderKey * 400"
      >
        <div class="resizable-wrapper-content" v-resizable-modal="'SYNC_LOG'">
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("SYNC_LOGS.ADD_SYNC_LOG") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button class="close" @click="closeSyncLogModal">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <!-- <add-sync-log-component @onViewSyncLog="openSyncLogViewModal" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Button } from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import SyncLogListTable from "./partials/SyncLogListTable.vue";
/* import EditSyncLogComponent from "./components/EditSyncLogComponent.vue";
import AddSyncLogComponent from "./components/AddSyncLogComponent.vue"; */
import ViewSyncLogComponent from "./components/ViewSyncLogComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    SyncLogListTable,
    NotificationSubscription,
    /* EditSyncLogComponent,
    AddSyncLogComponent, */
    ViewSyncLogComponent,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  computed: {},

  watch: {},

  data() {
    const syncLogId = this.$route.query.id;
    const action = this.$route.query.action;
    let isViewSyncLogModalOpened = false;
    let isEditSyncLogModalOpened = false;
    let isAddSyncLogModalOpened = false;
    let openSyncLog = null;
    if (syncLogId && action) {
      if (action === QUERY_ACTIONS_VIEW) {
        isViewSyncLogModalOpened = true;
      } else if (action === QUERY_ACTIONS_EDIT) {
        isEditSyncLogModalOpened = true;
      }
      openSyncLog = { id: syncLogId };
    } else if (action === QUERY_ACTIONS_ADD) {
      isAddSyncLogModalOpened = true;
    }
    return {
      isViewSyncLogModalOpened: isViewSyncLogModalOpened,
      isEditSyncLogModalOpened: isEditSyncLogModalOpened,
      isAddSyncLogModalOpened: isAddSyncLogModalOpened,
      openSyncLog: openSyncLog,
      renderKey: 1,
    };
  },

  methods: {
    openSyncLogCreateModal() {
      this.closeSyncLogModal();
      this.isAddSyncLogModalOpened = true;

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List SyncLogs",
          query: { action: QUERY_ACTIONS_ADD },
        }).href
      );
    },
    openSyncLogViewModal(syncLog, reRender = false) {
      this.closeSyncLogModal();
      this.openSyncLog = syncLog;
      this.isViewSyncLogModalOpened = true;
      if (reRender) {
        this.renderKey++;
      }

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List SyncLogs",
          query: { id: this.openSyncLog.id, action: QUERY_ACTIONS_VIEW },
        }).href
      );
    },
    openSyncLogEditModal(syncLog) {
      this.closeSyncLogModal();
      this.openSyncLog = syncLog;
      this.isEditSyncLogModalOpened = true;

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List SyncLogs",
          query: { id: this.openSyncLog.id, action: QUERY_ACTIONS_EDIT },
        }).href
      );
    },
    closeSyncLogModal() {
      this.isAddSyncLogModalOpened = false;
      this.isViewSyncLogModalOpened = false;
      this.isEditSyncLogModalOpened = false;
      this.openSyncLog = null;

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List SyncLogs",
          query: {},
        }).href
      );
    },

    async deleteSyncLog(syncLog) {
      const confirmation = await swal.fire({
        title: this.$t("SYNC_LOGS.DELETE_THIS_SYNC_LOG"),
        type: "question",
        customClass: {
          popup: "delete-popup",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("syncLogs/destroy", syncLog.id);
          this.renderKey++;
          this.closeSyncLogModal();
          this.$notify({
            type: "success",
            message: this.$t("SYNC_LOGS.SYNC_LOG_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async relunchSync(syncLog) {
      const confirmation = await swal.fire({
        text: this.$t("SYNC_LOGS.RETRY_THIS_SYNC"),
        type: "question",
        customClass: {
          popup: "warning-confirm",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("syncLogs/retry", syncLog.id);
          this.renderKey++;
          this.closeSyncLogModal();
          this.$notify({
            type: "success",
            message: this.$t("SYNC_LOGS.SYNC_RELAUNCHED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async toggleAttempts(syncLog) {
      const confirmation = await swal.fire({
        text: this.$t("SYNC_LOGS.UPDATE_THIS_SYNC_AUTO_ATTEMPTS"),
        type: "question",
        customClass: {
          popup: "warning-confirm",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("syncLogs/toggleAttempts", syncLog.id);
          this.renderKey++;
          this.closeSyncLogModal();
          this.$notify({
            type: "success",
            message: this.$t("SYNC_LOGS.AUTO_ATTEMPTS_UPDATED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
